import { render } from "./mispadres2_ingles.vue?vue&type=template&id=55e641d2&scoped=true"
import script from "./mispadres2_ingles.vue?vue&type=script&lang=js"
export * from "./mispadres2_ingles.vue?vue&type=script&lang=js"

import "./mispadres2_ingles.vue?vue&type=style&index=0&id=55e641d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e641d2"]])

export default __exports__